<template>
  <div class="drivers container-fluid r-aside">
    <loading :active.sync="isLoading" :can-cancel="true"> </loading>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Driver Details</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">Driver Details</li>
        </ol>
      </div>
    </div>
    <div v-if="driver" class="row">
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Driver Profile
              </h4>
              <div
                v-if="
                  getUser()['is_agent'] ||
                  getUser()['is_admin'] ||
                  getUser()['is_superuser']
                "
                class="btn-group ml-auto m-t-10"
              >
                <a
                  href="JavaScript:void(0)"
                  class="icon-options-vertical link"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></a>
                <div
                  v-if="driver.id_driver"
                  class="dropdown-menu dropdown-menu-right"
                >
                  <a
                    v-if="
                      driver.id_driver.id_type_driver_status
                        .id_type_driver_status != 1
                    "
                    @click="changeDriverStatus(1)"
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#instructionsModal"
                    >Activate Driver</a
                  >
                  <a
                    v-if="
                      driver.id_driver.id_type_driver_status
                        .id_type_driver_status != 2
                    "
                    @click="changeDriverStatus(2)"
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#cancelModal"
                    >Deactivate Driver</a
                  >
                  <a
                    v-if="
                      driver.id_driver.id_type_driver_status
                        .id_type_driver_status != 3
                    "
                    @click="changeDriverStatus(3)"
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#noshowRiderModal"
                    >Suspend Driver</a
                  >
                  <!--<a v-if="driver.id_driver.id_type_driver_status.id_type_driver_status != 4" @click="changeDriverStatus(4)" class="dropdown-item" data-toggle="modal" data-target="#noshowDriverModal" >Idle</a>-->
                  <div class="dropdown-divider"></div>
                  <a
                    @click="contact_edit = true"
                    class="dropdown-item"
                    data-toggle="modal"
                    >Update Driver's Contact Information</a
                  >
                  <div class="dropdown-divider"></div>
                  <a
                    @click="
                      mergedRides = active.concat(upco);
                      showDistConfirmModal = true;
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#noshowRiderModal"
                    >Distribute Driver's Rides</a
                  >
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="resetPassword()"
                    >Send password reset email</a
                  >

                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="showTestRideConfirmationModal = true">
                    Send test ride
                  </a>

                  <div
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-divider"
                  ></div>
                  <a
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-item"
                    @click="showAdditionalModal = true"
                    data-toggle="modal"
                    data-target="#updatePickupModal"
                    style="cursor: pointer"
                    >Add Payment/Penalty to the Driver</a
                  >
                  <div
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-divider"
                  ></div>
                  <a
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-item"
                    @click="showInstallmentModal = true"
                    data-toggle="modal"
                    style="cursor: pointer"
                    >Add Installment Payments</a
                  >
                  <div
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-divider"
                  ></div>
                  <a
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-item"
                    @click="showAccountTypeModal = true"
                    data-toggle="modal"
                    data-target="#updateAccountTypeModal"
                    style="cursor: pointer"
                    >Change Driver's Account Type</a
                  >
                  <div
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-divider"
                  ></div>
                  <a
                    v-if="getUser()['is_admin'] || getUser()['is_superuser']"
                    class="dropdown-item"
                    @click="showVehicleTypeModal = true"
                    data-toggle="modal"
                    data-target="#updateVehicleTypeModal"
                    style="cursor: pointer"
                    >Change Driver's Vehicle Type</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 text-center mb-3 row">
              <div class="col-12">
                <a
                  v-bind:href="
                    api_url + 'driver-info/' + driver.id_random + '/'
                  "
                >
                  <img
                    v-if="driver.id_profile_image"
                    class="rounded-circle"
                    style="height: 100px; width: 100px; object-fit: cover"
                    :src="driver.id_profile_image.url"
                    alt="No profile picture"
                  />
                </a>
                <font-awesome-icon
                  v-if="!driver.id_profile_image"
                  icon="user-circle"
                  style="height: 100px; width: 100px; color: grey"
                />
                <div class="col-12">
                  <span class="font-weight-bold text-center"
                    >{{ driver.name_first }} {{ driver.name_last }}</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12" v-if="driver.id_driver.id_type_driver_status">
              <span class="font-weight-bold"> Status: </span>
              {{ driver.id_driver.id_type_driver_status.name }}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Driver Activated Since:</span>
              {{
                !driver.id_driver.activated_at
                  ? "N/A"
                  : moment(driver.id_driver.activated_at).format(
                      "YYYY-MM-DD HH:mm"
                    ) +
                    " (" +
                    moment.tz.guess() +
                    ")"
              }}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Date of First Trip:</span>
              {{
                !driver.date_first_trip
                  ? "N/A"
                  : moment(driver.date_first_trip).format(
                      "YYYY-MM-DD HH:mm"
                    ) +
                    " (" +
                    moment.tz.guess() +
                    ")"
              }}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Driver Market:</span>
              {{
                !driver.id_driver.id_market
                  ? "N/A"
                  : driver.id_driver.id_market.name
              }}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Driver Type:</span>
              {{
                !driver.id_driver.id_type_driver_account
                  ? "N/A"
                  : driver.id_driver.id_type_driver_account.code.replace(
                      driver.id_driver.id_type_driver_account.code.charAt(0),
                      driver.id_driver.id_type_driver_account.code
                        .charAt(0)
                        .toUpperCase()
                    )
              }}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Rides Completed:</span>
              {{ driver.rides_amount }}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Vehicle Type:</span>
              {{ vehicleType }}
            </div>

            <div class="col-12">
              <hr />
            </div>
            <div class="col-12">
              <span class="font-weight-bold">First Name:</span>
              <a v-if="!contact_edit">{{
                driver.name_first ? driver.name_first : ""
              }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.name_first"
                    label="First Name"
                    input-class="form-control form-control-sm"
                    placeholder="First Name"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.name_first = driverFirstName_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Last Name:</span>
              <a v-if="!contact_edit">{{
                driver.name_last ? driver.name_last : ""
              }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.name_last"
                    label="Last Name"
                    input-class="form-control form-control-sm"
                    placeholder="Last Name"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.name_last = driverLastName_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Phone:</span>
              <a v-if="!contact_edit">{{
                driver.phone_number ? driver.phone_number : ""
              }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.phone_number"
                    label="Phone Number"
                    input-class="form-control form-control-sm"
                    placeholder="Phone Number"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.phone_number = driverPhone_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Email:</span>
              <a v-if="!contact_edit">{{ driver.email ? driver.email : "" }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.email"
                    label="Email"
                    input-class="form-control form-control-sm"
                    placeholder="Email"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.email = driverEmail_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Bio:</span>
              <a v-if="!contact_edit">{{ driver.bio ? driver.bio : "" }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.bio"
                    label="Email"
                    input-class="form-control form-control-sm"
                    placeholder="Email"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.bio = driverBio_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Address:</span>
              <a v-if="!contact_edit">{{
                driver.location_address_1 ? driver.location_address_1 : ""
              }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.location_address_1"
                    label="Email"
                    input-class="form-control form-control-sm"
                    placeholder="Email"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.location_address_1 = driverAddress_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">County:</span>
              <a v-if="!contact_edit">{{
                driver.location_county ? driver.location_county : ""
              }}</a>
              <td v-else>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <input
                    v-model="driver.location_county"
                    label="County"
                    input-class="form-control form-control-sm"
                    placeholder="County"
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      driver.location_county = location_county_bk;
                    "
                    icon="times"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(239, 83, 80);
                      cursor: pointer;
                    "
                  />
                  <font-awesome-icon
                    @click="
                      contact_edit = false;
                      updateDriver();
                    "
                    icon="check"
                    style="
                      float: right;
                      margin: 5px;
                      color: rgb(38, 166, 154);
                      cursor: pointer;
                    "
                  />
                </div>
              </td>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Vehicle</h4>
            </div>
          </div>

          <div class="card-body">
            <div v-if="driver.vehicles.length != 0">
              <div class="col-12 mt-3 mb-3 text-center">
                <img
                  v-if="driver.vehicles[0].id_image"
                  class=""
                  style="max-height: 200px; max-width: 200px"
                  :src="driver.vehicles[0].id_image.url"
                  alt="A13553cd07ac273dc7118c8c5985e19344033417086e7f4e1e7a8aeafbb525f8"
                />
                <font-awesome-icon
                  v-if="!driver.vehicles[0].id_image"
                  icon="car"
                  style="height: 100px; width: 100px; color: grey"
                />
              </div>

              <div class="col-12">
                <span class="font-weight-bold">Make &amp; model:</span>
                {{
                  driver.vehicles &&
                  driver.vehicles[0].year &&
                  driver.vehicles[0].model &&
                  driver.vehicles[0].id_make_vehicle &&
                  driver.vehicles[0].id_make_vehicle.name
                    ? driver.vehicles[0].year +
                      " " +
                      driver.vehicles[0].id_make_vehicle.name +
                      " " +
                      driver.vehicles[0].model
                    : "N/A"
                }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold">License Plate:</span>
                {{
                  driver.vehicles && driver.vehicles[0].license_plate_number
                    ? driver.vehicles[0].license_plate_number
                    : "N/A"
                }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold">VIN #:</span>
                {{
                  driver.vehicles && driver.vehicles[0].vin
                    ? driver.vehicles[0].vin
                    : "N/A"
                }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold">Decal #:</span>
                {{
                  driver.vehicles && driver.vehicles[0].seti_decal
                    ? driver.vehicles[0].seti_decal
                    : "N/A"
                }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold">Category:</span>
                {{
                  driver.vehicles && driver.vehicles[0].id_type_vehicle
                    ? driver.vehicles[0].id_type_vehicle.code
                    : "N/A"
                }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold">Capacity:</span>
                {{
                  driver.vehicles &&
                  driver.vehicles[0].id_type_vehicle &&
                  driver.vehicles[0].id_type_vehicle.capacity
                    ? driver.vehicles[0].id_type_vehicle.capacity
                    : "N/A"
                }}
              </div>
            </div>
            <div v-if="driver.vehicles.length == 0">N/A</div>
          </div>
        </div>

        <div
          v-if="
            getUser()['is_agent'] ||
            getUser()['is_admin'] ||
            getUser()['is_superuser']
          "
          class="card"
        >
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Payout History
              </h4>
            </div>
          </div>
          <div class="card-body table-responsive">
            <table id="payments-table" class="table table-hover table-sm">
              <thead>
                <tr>
                  <th>Date (transferred)</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="payments && payments.length > 0"
                  v-for="payment in payments"
                >
                  <td class="">
                    {{
                      moment(payment.date_processed).format(
                        "YYYY-MM-DD HH:mm"
                      ) +
                      " (" +
                      moment.tz.guess() +
                      ")"
                    }}
                  </td>
                  <td class="">
                    ${{
                      (-payment.amount)
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                    }}
                  </td>
                </tr>
                <tr v-if="!payments || payments.length == 0">
                  <td colspan="2" style="text-align: center">N/A</td>
                </tr>
              </tbody>
            </table>
            <input
              @click="viewDashboard()"
              type="submit"
              name="commit"
              value="View Dashboard"
              class="btn btn-info waves-effect waves-light m-t-10"
              data-disable-with="View Dashboard"
            />
            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']">
              <input
                v-if="balance != null && balance > 0"
                @click="payBalance()"
                type="submit"
                name="commit"
                :value="
                  'Process final payout ($' +
                  balance.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +
                  ')'
                "
                class="btn btn-info waves-effect waves-light m-t-10"
              />
              <input
                v-if="balance != null && balance <= 0"
                @click="payBalance()"
                type="submit"
                name="commit"
                :value="
                  'Process final payout ($' +
                  balance.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +
                  ')'
                "
                class="btn btn-info waves-effect waves-light m-t-10"
                disabled
                style="background-color: grey; border-color: grey"
              />
            </div>
            <div v-if="getUser()['is_admin'] || getUser()['is_superuser']">
              <input
                v-if="balance != null && balance > 0"
                @click="showManualPayoutModal = true"
                type="submit"
                name="commit"
                :value="'Create payout'"
                class="btn btn-info waves-effect waves-light m-t-10"
              />
              <input
                v-if="balance != null && balance <= 0"
                @click="showManualPayoutModal = true"
                type="submit"
                name="commit"
                :value="'Create payout'"
                class="btn btn-info waves-effect waves-light m-t-10"
                disabled
                style="background-color: grey; border-color: grey"
              />
            </div>
          </div>
        </div>

        <div
          v-if="getUser()['is_admin'] || getUser()['is_superuser']"
          class="card"
        >
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Update Bank Information
              </h4>
            </div>
          </div>
          <div class="card-body">
            <div>
              <div>
                <P>* Update only of existing bank account information</P>
                <h4>Routing Number</h4>
                <input
                  v-model="routingNumber"
                  class="form-control"
                  placeholder="Routing Number"
                  style="width: 30%"
                  type="number"
                />
              </div>
              <br />
              <div>
                <h4>Account Number</h4>
                <input
                  v-model="accountNumber"
                  class="form-control"
                  placeholder="Account Number"
                  style="width: 30%"
                  type="number"
                />
              </div>
              <br />
              <div>
                <h4>Social Security Number (Last 4)</h4>
                <input
                  v-model="ssn"
                  class="form-control"
                  placeholder="SSN"
                  style="width: 30%"
                  type="number"
                />
              </div>
              <br />
              <button
                id="save-bank-button"
                v-on:click="updateBankInfo()"
                class="btn btn-info waves-effect waves-light m-t-10"
              >
                Update Bank Information
              </button>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Actions & Comments
              </h4>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="comments-table" class="table table-sm table-hover">
                <thead>
                  <tr>
                    <td style="border: none"></td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="comment in comments"
                    class="col-12 mt-2 p-3"
                    v-bind:style="
                      comment.content_type == 'action'
                        ? 'background-color:#f3f1f1'
                        : ''
                    "
                  >
                    <td>
                      <p class="pull-right">
                        <small>{{
                          moment(comment.created_at).format(
                            "MMMM Do, YYYY \\at h:mm a"
                          ) +
                          " (" +
                          moment.tz.guess() +
                          ")"
                        }}</small>
                      </p>
                      <div class="media-body">
                        <h6 class="media-heading user_name">
                          {{
                            comment.commented_by.name_first +
                            " " +
                            comment.commented_by.name_last
                          }}
                        </h6>
                        <p>{{ comment.content }}</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- <div class="col-12 mt-2 p-3" style="overflow-y: scroll; max-height:400px;">
              <div v-for="comment in comments" class="col-12 mt-2 p-3 border" v-bind:style="comment.content_type == 'action' ? 'background-color:gray' : ''">
                <p class="pull-right">
                  <small>{{ comment.created_at | moment('timezone', driver.location_timezone, "MMMM Do, YYYY \\at h:mm a") }}</small>
                </p>
                <div class="media-body">
                  <h6 class="media-heading user_name">{{ comment.commented_by.name_first + ' ' + comment.commented_by.name_last}}</h6>
                  <p>{{comment.content}}</p>
                </div>
              </div>
            </div> -->

            <div class="col-12 mt-2 p-3">
              <textarea
                class="form-control form-sm"
                style="height: 100px"
                name="comment[comment]"
                id="comment_comment"
                v-model="comment_content"
              ></textarea>
              <input
                @click="addComment()"
                type="submit"
                name="commit"
                value="Add Comment"
                class="btn btn-info waves-effect waves-light m-t-10"
                data-disable-with="Add Comment"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Active Rides
              </h4>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="active-rides-table" class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!active || active.length == 0">
                    <th colspan="2" style="text-align: center">N/A</th>
                  </tr>
                  <template v-for="ride in active">
                    <tr>
                      <td>
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        <div>
                          <span class="font-weight-bold">Date:</span>
                          {{
                            moment(ride.date_pickup).format(
                              "YYYY-MM-DD HH:mm"
                            ) +
                            " (" +
                            moment.tz.guess() +
                            ")"
                          }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Status:</span>
                          {{
                            ride.id_type_ride_status &&
                            ride.id_type_ride_status.name
                              ? ride.id_type_ride_status.name
                              : ""
                          }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Pickup:</span>
                          {{ ride.default_pickup_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Dropoff:</span>
                          {{ ride.default_dropoff_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Duration:</span>
                          {{
                            Number(
                              (ride.default_duration_p_to_d / 60).toFixed(1)
                            )
                          }}
                          minutes
                          <span class="font-weight-bold">Distance:</span>
                          {{ ride.default_distance_p_to_d.toFixed(2) }}
                          miles
                        </div>
                      </td>
                    </tr>
                  </template>
                    <tr>
                    <td colspan="2">
                      <div class="cus-pagination">
                        <div style="margin: 1rem 1rem; float: left">
                          <span v-if="totalActRows > 0"
                            >Showing
                            {{ perPage * (actCurrentPage - 1) + 1 }} to
                            {{
                              perPage * actCurrentPage > totalActRows
                                ? totalActRows
                                : perPage * actCurrentPage
                            }}
                            of {{ totalActRows }} entries</span
                          >
                          <span v-else>Showing 0 entries</span>
                        </div>

                        <div style="margin: 0 1rem; float: right">
                          <b-pagination
                            style="margin: 0.5rem 0"
                            align="center"
                            :total-rows="totalActRows"
                            v-model="actCurrentPage"
                            :per-page="perPage"
                            :limit="limit"
                            @change="changeActPage"
                          >
                          </b-pagination>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Upcoming Rides
              </h4>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table
                id="upcoming-rides-table"
                class="table table-hover table-sm"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!upco || upco.length == 0">
                    <th colspan="2" style="text-align: center">N/A</th>
                  </tr>
                  <template v-for="ride in upco">
                    <tr>
                      <td>
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        <div>
                          <span class="font-weight-bold">Date:</span>
                          {{
                            moment(ride.date_pickup).format(
                              "YYYY-MM-DD HH:mm"
                            ) +
                            " (" +
                            moment.tz.guess() +
                            ")"
                          }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Pickup:</span>
                          {{ ride.default_pickup_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Dropoff:</span>
                          {{ ride.default_dropoff_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Duration:</span>
                          {{
                            Number(
                              (ride.default_duration_p_to_d / 60).toFixed(1)
                            )
                          }}
                          minutes
                          <span class="font-weight-bold">Distance:</span>
                          {{ ride.default_distance_p_to_d.toFixed(2) }}
                          miles
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr>
                    <td colspan="2">
                      <div class="cus-pagination">
                        <div style="margin: 1rem 1rem; float: left">
                          <span v-if="totalUpcRows > 0"
                            >Showing
                            {{ perPage * (upcCurrentPage - 1) + 1 }} to
                            {{
                              perPage * upcCurrentPage > totalUpcRows
                                ? totalUpcRows
                                : perPage * upcCurrentPage
                            }}
                            of {{ totalUpcRows }} entries</span
                          >
                          <span v-else>Showing 0 entries</span>
                        </div>

                        <div style="margin: 0 1rem; float: right">
                          <b-pagination
                            style="margin: 0.5rem 0"
                            align="center"
                            :total-rows="totalUpcRows"
                            v-model="upcCurrentPage"
                            :per-page="perPage"
                            :limit="limit"
                            @change="changeUpcPage"
                          >
                          </b-pagination>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Previous Rides
              </h4>
            </div>
          </div>

          <div class="card-body">
            <div class="col-12 table-responsive">
              <table
                id="previous-rides-table"
                class="table table-hover table-sm"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Details</th>
                    <th>Status</th>
                  </tr>
                  <tr v-if="!prev || prev.length == 0">
                    <td colspan="2" style="text-align: center">N/A</td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="ride in prev">
                    <tr>
                      <td>
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        <div>
                          <span class="font-weight-bold">Date:</span>
                          {{
                            moment(ride.date_pickup).format(
                              "YYYY-MM-DD HH:mm"
                            ) +
                            " (" +
                            moment.tz.guess() +
                            ")"
                          }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Pickup:</span>
                          {{ ride.default_pickup_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Dropoff:</span>
                          {{ ride.default_dropoff_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold">Duration:</span>
                          {{
                            Number(
                              (ride.default_duration_p_to_d / 60).toFixed(1)
                            )
                          }}
                          minutes
                          <span class="font-weight-bold">Distance:</span>
                          {{ ride.default_distance_p_to_d.toFixed(2) }}
                          miles
                        </div>
                      </td>
                      <td>
                          {{ ride.id_type_ride_status.name }}
                      </td>
                    </tr>
                  </template>
                  <tr>
                    <td colspan="3">
                      <div class="cus-pagination">
                        <div style="margin: 1rem 1rem; float: left">
                          <span v-if="totalPrevRows > 0"
                            >Showing
                            {{ perPage * (prevCurrentPage - 1) + 1 }} to
                            {{
                              perPage * prevCurrentPage > totalPrevRows
                                ? totalPrevRows
                                : perPage * prevCurrentPage
                            }}
                            of {{ totalPrevRows }} entries</span
                          >
                          <span v-else>Showing 0 entries</span>
                        </div>

                        <div style="margin: 0 1rem; float: right">
                          <b-pagination
                            style="margin: 0.5rem 0"
                            align="center"
                            :total-rows="totalPrevRows"
                            v-model="prevCurrentPage"
                            :per-page="perPage"
                            :limit="limit"
                            @change="changePrevPage"
                          >
                          </b-pagination>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title">
                <span class="lstick"></span>Zone Preference
              </h4>
            </div>
          </div>
          <div class="card-body card-map-body">
            <span>* Zoom in to the zone you would like to select.</span>
            <br />
            <span
              >* Press the "Draw" button to define the area(s) for which you
              would like to receive trip requests. You will see available trips
              that have pick-up or drop-off points within the areas you
              define.</span
            >
            <br />
            <input
              v-if="
                (getUser()['is_agent'] ||
                  getUser()['is_admin'] ||
                  getUser()['is_superuser']) &&
                showDraw
              "
              @click="draw()"
              type="submit"
              name="commit"
              value="Draw"
              class="btn btn-info waves-effect waves-light m-t-10"
              data-disable-with="Draw"
              style="margin-bottom: 15px"
            />
            <!--<button v-if="showDraw" id="button-load" v-on:click="loadPolygons">Load</button>-->
            <input
              v-if="
                (getUser()['is_agent'] ||
                  getUser()['is_admin'] ||
                  getUser()['is_superuser']) &&
                showCancel
              "
              @click="cancelDraw()"
              type="submit"
              name="commit"
              value="Cancel"
              class="btn btn-info waves-effect waves-light m-t-10"
              data-disable-with="Cancel"
              style="margin-bottom: 15px"
            />
            <input
              v-if="
                (getUser()['is_agent'] ||
                  getUser()['is_admin'] ||
                  getUser()['is_superuser']) &&
                showSave
              "
              @click="saveDraw()"
              type="submit"
              name="commit"
              value="Save"
              class="btn btn-info waves-effect waves-light m-t-10"
              data-disable-with="Save"
              style="margin-bottom: 15px"
            />
            <div class="d-flex">
              <div
                id="map"
                style="width: 100%; height: 500px; margin: auto"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Driver deactivation ride distribution modal -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showDriverDistributionModal"
            @close="showDriverDistributionModal = false"
          >
            <h3 slot="header">
              Would you like to distribute this driver's rides?
            </h3>
            <div slot="body">
              <div>
                All the upcoming rides for this driver that are not started will
                be sent to general distribution.
              </div>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="
                  distributeDriver(), (showDriverDistributionModal = false)
                "
              >
                Yes
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showDriverDistributionModal = false"
              >
                No
              </button>
            </div>
          </modal>
        </div>
      </div>

      <!-- Ride distribution confirmation modal -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showDistConfirmModal"
            @close="showDistConfirmModal = false"
          >
            <h3 slot="header">
              Are you sure you want to distribute this driver's rides?
            </h3>
            <div slot="body">
              <div>
                Please select rides that need to be distributed for driver
                <span style="font-weight: bold">{{
                  driver.name_first + " " + driver.name_last
                }}</span
                >.
              </div>

              <div class="row" style="margin: 1rem 0 1rem 0">
                <div class="col-md-3 col-lg-3 p-0">
                  <!--<div class="m-3 form-ddown">-->
                  <!--<label class="search-label">Start</label>-->
                  <div class="row" style="margin-left: 0.1rem">
                    <datetime
                      type="datetime"
                      v-model="min_date"
                      input-class="form-control form-control-sm"
                      placeholder="Start"
                      label="Start"
                      :noClearButton="false"
                    >
                    </datetime>
                    <font-awesome-icon
                      v-if="min_date"
                      @click="clearDate('min_date')"
                      icon="times"
                      style="
                        color: grey;
                        cursor: pointer;
                        margin: 0.5rem 0 0 0.5rem;
                      "
                    />
                  </div>
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp to &nbsp&nbsp&nbsp
                <div class="col-md-3 col-lg-3 p-0">
                  <!--<div class="m-3 form-ddown">-->
                  <!--<label class="search-label">End</label>-->
                  <div class="row" style="margin-left: 0.1rem">
                    <datetime
                      type="datetime"
                      v-model="max_date"
                      label="End"
                      input-class="form-control form-control-sm"
                      placeholder="End"
                    >
                    </datetime>
                    <font-awesome-icon
                      v-if="max_date"
                      @click="clearDate('max_date')"
                      icon="times"
                      style="
                        color: grey;
                        cursor: pointer;
                        margin: 0.5rem 0 0 0.5rem;
                      "
                    />
                  </div>
                  <!--</div>-->
                </div>
                &nbsp&nbsp&nbsp
                <span>(Filter by pick-up date)</span>
              </div>

              <div style="height: 400px; overflow-y: auto !important">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th class="result-label text-center" width="10%">
                        <select
                          class="form-control table-select"
                          @change="checkSelection($event)"
                          onfocus="this.selectedIndex = 0"
                        >
                          <option selected="selected">Select</option>
                          <option>All</option>
                          <option>None</option>
                        </select>
                      </th>
                      <th>Ride ID</th>
                      <th>Leg ID</th>
                      <th>Pick-up date</th>
                      <th>Rider name</th>
                      <th>From</th>
                      <th>To</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="ride in mergedRides">
                      <td class="result-item text-center">
                        <input
                          v-bind:id="ride.id_ride"
                          v-if="ride"
                          type="checkbox"
                          v-bind:value="ride"
                          v-model="checked"
                        />
                        <label
                          class="search-label"
                          v-bind:for="ride.id_ride"
                          style="margin-bottom: 0; top: 0px"
                        ></label>
                      </td>
                      <td>
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          {{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        {{ ride.id_alternate ? ride.id_alternate : "N/A" }}
                      </td>
                      <td>
                        {{
                          moment(ride.date_pickup).format("YYYY-MM-DD HH:mm") +
                          " (" +
                          moment().tz(moment.tz.guess()).format("z") +
                          ")"
                        }}
                      </td>
                      <td>
                        {{
                          ride.id_rider
                            ? ride.id_rider.name_first +
                              " " +
                              ride.id_rider.name_last
                            : "N/A"
                        }}
                      </td>
                      <td>{{ ride.default_pickup_address }}</td>
                      <td>{{ ride.default_dropoff_address }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="distributeDriver(), (showDistConfirmModal = false)"
              >
                Distribute
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showDistConfirmModal = false"
              >
                Cancel
              </button>
            </div>
          </modal>
        </div>
      </div>

      <!-- Test ride confirmation modal -->
      <div id="testRideConfirmationModal">
        <modal
          v-if="showTestRideConfirmationModal"
          @close="showTestRideConfirmationModal = false"
        >
          <h3 slot="header">Confirm Sending Test Ride</h3>
          <div slot="body"></div>
          <div slot="footer" >
            <button
              class="modal-default-button btn btn-info waves-effect waves-light m-t-10"
              @click="showTestRideConfirmationModal = false; sendTestRide()"
            >
              Submit
            </button>
            <button
              class="modal-default-button btn btn-default m-t-10"
              @click="showTestRideConfirmationModal = false"
            >
              Cancel
            </button>
          </div>
        </modal>
      </div>

      <!-- Test ride confirmation modal -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showTestRideConfirmModal"
            @close="showTestRideConfirmModal = false"
          >
            <h3 slot="header">
              Successfully sent a test ride to the driver
            </h3>
            <div slot="body">
              <div>
                <router-link :to="'/rides/' + this.testRideId + '/'">
                  <!--<router-link :to="{name: 'Rides', params: {id_ride: ride.id_ride}}">-->
                  #{{ this.testRideId }}
                </router-link>
              </div>
            </div>
            <div slot="footer">
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showTestRideConfirmModal = false"
              >
                OK
              </button>
            </div>
          </modal>
        </div>
      </div>

      <!-- Add additional payment popup alert -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showAdditionalModal"
            @close="showAdditionalModal = false"
          >
            <h3 slot="header">Add Additional Payment</h3>
            <div slot="body">
              <form v-on:submit.prevent class="form-material">
                <div class="my-3">
                  <label class="search-label">Amount: $</label>
                  <input
                    v-model="additional_payment_amount"
                    class="form-control form-control-sm"
                    placeholder="Amount"
                    style="width: 100%"
                    type="text"
                  />
                </div>
                <div class="my-3">
                  <label class="search-label">Comment:</label>
                  <textarea
                    v-model="additional_payment_comment"
                    class="form-control form-control-sm"
                    placeholder="Comment"
                    style="width: 100%; resize: auto"
                    rows="3"
                  >
                  </textarea>
                </div>
              </form>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="addAdditionalPayment()"
              >
                Add
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showAdditionalModal = false"
              >
                Cancel
              </button>
            </div>
          </modal>
        </div>
      </div>
      <!-- Add Installment payment popup alert -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showInstallmentModal"
            @close="showInstallmentModal = false"
            style="width: 600px"
          >
            <h3 slot="header">Add Installments Payments</h3>
            <div slot="body">
              <form v-on:submit.prevent class="form-material">
                <div class="my-3">
                  <label class="search-label">Installment Amount: $</label>
                  <input
                    v-model="installment_payment_amount"
                    class="form-control form-control-sm"
                    placeholder="Installment Amount"
                    style="width: 100%"
                    type="text"
                  />
                </div>
                <div class="my-3">
                  <label class="search-label">How many Installments: </label>
                  <input
                    v-model="installment_count"
                    class="form-control form-control-sm"
                    placeholder="Installment Count"
                    style="width: 100%"
                    type="text"
                  />
                </div>
                <div class="my-3">
                  <label class="search-label">Installment interval: </label>
                  <select
                    class="form-control ddown"
                    v-model="installment_interval"
                  >
                    <option value="week">Weekly</option>
                    <option value="month">Monthly</option>
                  </select>
                </div>
                <div class="my-3">
                  <label class="search-label">Start Date: </label>
                  <datetime
                    type="datetime"
                    v-model="installment_start_date"
                    input-class="form-control form-control-sm"
                    placeholder="Installment Start Date"
                  >
                  </datetime>
                </div>

                <div class="my-3">
                  <label class="search-label">Description:</label>
                  <textarea
                    v-model="installment_description"
                    class="form-control form-control-sm"
                    placeholder="Description"
                    style="width: 100%; resize: auto"
                    rows="5"
                  >
                  </textarea>
                </div>
              </form>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="addInstallmentPayment(false)"
              >
                Add
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showInstallmentModal = false"
              >
                Cancel
              </button>
            </div>
          </modal>
        </div>
      </div>
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showInstallmentConfirmModal"
            @close="showInstallmentConfirmModal = false"
            style="width: 600px"
          >
            <!-- <h3 slot="header">
              Change this driver's account type to:
            </h3> -->
            <h3 slot="header">Confirm Installments:</h3>

            <div slot="body">
              <table id="payments-table" class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in installments">
                    <td class="">
                      {{ moment(i.date_approved).format("YYYY-MM-DD") }}
                    </td>
                    <td class="">{{ i.comment }}</td>
                    <td class="">${{ i.amount }}</td>
                  </tr>
                  <tr>
                    <td class="" colspan="2"><b>Total</b></td>
                    <td class="">${{ installment_total }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="addInstallmentPayment(true)"
              >
                Confirm
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="
                  showInstallmentConfirmModal = false;
                  showInstallmentModal = true;
                "
              >
                Back
              </button>
            </div>
          </modal>
        </div>
      </div>
      <!-- Change account type popup alert -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showAccountTypeModal"
            @close="showAccountTypeModal = false"
          >
            <h3 slot="header">Change this driver's account type to:</h3>
            <div slot="body">
              <form v-on:submit.prevent class="form-material">
                <div class="my-3">
                  <select
                    type="text"
                    placeholder="Market"
                    class="form-control ddown"
                    id="market-filter"
                    v-model="selected_account_type"
                  >
                    <option v-bind:value="1">Individual</option>
                    <option v-bind:value="5">Deadhead</option>
                  </select>
                </div>
              </form>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="updateAccountType()"
              >
                Update
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showAccountTypeModal = false"
              >
                Cancel
              </button>
            </div>
          </modal>
        </div>
      </div>

      <!-- Change vehicle type popup alert -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showVehicleTypeModal"
            @close="showVehicleTypeModal = false"
          >
            <h3 slot="header">Change the vehicle type:</h3>
            <div slot="body">
              <!-- <form v-on:submit.prevent class="form-material">
                <div class="my-3">
                  <multiselect
                    placeholder="Select vehicle type"
                    v-model="selectedVehicleType"
                    :options="vehicleOptions"
                    label="name"
                    track-by="name"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag"
                  ></multiselect>
                </div>
              </form> -->
              <div class="checkbox-item">
                <form class="checkbox-form">
                  <ul class="checkbox-list">
                    <li v-for="(options, index) in vehicleOptions" :key="index">
                      <input
                        type="checkbox"
                        name="check"
                        :id="index"
                        :value="options.name"
                        v-model="selectedVehicleType"
                      />
                      <label :for="index">{{ options.name }}</label>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="updateVehicleType()"
              >
                Update
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showVehicleTypeModal = false"
              >
                Cancel
              </button>
            </div>
          </modal>
        </div>
      </div>

      <!-- Add pay popup alert -->
      <div>
        <div>
          <!-- use the modal component, pass in the prop -->
          <modal
            v-if="showManualPayoutModal"
            @close="showManualPayoutModal = false"
            style="width: 600px"
          >
            <h3 slot="header">
              Please enter the amount below. Please note it should be less than
              or equal to the driver's balance ${{ balance }}
            </h3>
            <div slot="body">
              <form v-on:submit.prevent class="form-material">
                <div class="my-3">
                  <label class="search-label">Amount: $</label>
                  <input
                    v-model="manualPayoutAmount"
                    class="form-control form-control-sm"
                    placeholder="Amount"
                    style="width: 100%"
                    type="text"
                  />
                </div>
              </form>
            </div>
            <div slot="footer">
              <button
                class="
                  modal-default-button
                  btn btn-info
                  waves-effect waves-light
                  m-t-10
                "
                @click="payBalance(true)"
              >
                Add
              </button>
              <button
                class="modal-default-button btn btn-default m-t-10"
                @click="showManualPayoutModal = false"
              >
                Cancel
              </button>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  metaInfo: {
    title: "Wingz Support | Drivers",
  },
  name: "Drivers",
  data() {
    return {
      isLoading: false,
      loadings: [],
      driver: null,
      prev: null,
      upco: null,
      active: null,
      comments: [],
      comment_content: null,
      status_list: null,
      selected: 1,
      payments: null,
      balance: null,
      map: null,
      showCancel: false,
      showSave: false,
      showDraw: true,
      shapes: [],
      lines: [],
      oldDrawing: null,
      api_url: process.env.API_BASE_URL,
      showDriverDistributionModal: false,
      showTestRideConfirmationModal: false,
      showTestRideConfirmModal: false,
      testRideId: null,
      showDistConfirmModal: false,
      showAdditionalModal: false,
      showInstallmentModal: false,
      showManualPayoutModal: false,
      contact_edit: false,
      driverFirstName_bk: null,
      driverLastName_bk: null,
      driverEmail_bk: null,
      driverPhone_bk: null,
      driverBio_bk: null,
      driverAddress_bk: null,
      location_county_bk: null,
      routingNumber: "",
      accountNumber: "",
      ssn: "",
      min_date: null,
      max_date: null,
      checked: [],
      mergedRides: null,
      additional_payment_amount: null,
      additional_payment_comment: null,
      showAccountTypeModal: false,
      showInstallmentConfirmModal: false,
      selected_account_type: null,
      installment_payment_amount: null,
      manualPayoutAmount: null,
      installment_count: null,
      installment_interval: "week",
      installment_start_date: null,
      installment_description: null,
      showVehicleTypeModal: false,
      vehicleOptions: [
        {
          name: "Ambulatory",
        },
        {
          name: "Wheelchair",
        },
      ],
      oldSelectedTypes: [],
      selectedVehicleType: [],
      deleteSelected: [],
      vehicleType: "",

      perPage : 5,
      limit: 5,

      //previous ride
      prevCurrentPage: 1,
      totalPrevRows: 0,

      //upcoming ride
      upcCurrentPage: 1,
      totalUpcRows: 0,

      //active ride
      actCurrentPage: 1,
      totalActRows: 0,
    };
  },
  components: {
    Loading,
    Multiselect,
  },
  watch: {
    oldSelectedTypes: function (val) {
      let tempArr = [];
      if (val)
        if (this.oldSelectedTypes)
          this.oldSelectedTypes.forEach((element) => {
            tempArr.push(element);
          });

      this.vehicleType = tempArr.length ? tempArr.join(", ") : "NA";
    },
    min_date: function (val, oldVal) {
      if (!val && !oldVal) return;

      if (val != oldVal) {
        console.log("needs refresh");

        // the value changed
        this.checked = [];

        for (let index = 0; index < this.mergedRides.length; index++) {
          let ride = this.mergedRides[index];

          if (val) {
            if (this.max_date) {
              if (
                val <= ride.date_pickup &&
                ride.date_pickup <= this.max_date
              ) {
                this.checked.push(ride);
              }
            } else {
              if (val <= ride.date_pickup) {
                this.checked.push(ride);
              }
            }
          } else {
            if (this.max_date) {
              if (ride.date_pickup <= this.max_date) {
                this.checked.push(ride);
              }
            } else {
              this.checked.push(ride);
            }
          }
        }
      }
    },
    max_date: function (val, oldVal) {
      console.log("val " + val);
      console.log("oldVal " + oldVal);

      if (!val && !oldVal) return;

      if (val != oldVal) {
        console.log("needs refresh");

        // the value changed
        this.checked = [];

        for (let index = 0; index < this.mergedRides.length; index++) {
          let ride = this.mergedRides[index];

          if (val) {
            if (this.min_date) {
              if (
                this.min_date <= ride.date_pickup &&
                ride.date_pickup <= val
              ) {
                this.checked.push(ride);
              }
            } else {
              if (ride.date_pickup <= val) {
                this.checked.push(ride);
              }
            }
          } else {
            if (this.min_date) {
              if (this.min_date <= ride.date_pickup) {
                this.checked.push(ride);
              }
            } else {
              this.checked.push(ride);
            }
          }
        }
      }
    },
  },
  computed: {
    installment_total() {
      if (this.installments) {
        var total = 0;
        // for (var i=0; i<this.installments.length; i++) {
        //   total += this.installments[i].amount
        // }

        for (const element of this.installments) {
          total += element.amount;
        }
        return total;
      } else {
        return 0;
      }
    },
  },
  methods: {
    // multiselect handler
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    async getVehicleTypeFields() {
      await this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "driver-tags/?driver=" +
            this.$route.params.id_driver
        )
        .then((response) => {
          //empty blank array
          //this.deleteSelected.length = 0;

          response.data.forEach((element) => {
            this.selectedVehicleType.push(element.value);
            this.deleteSelected.push(element.id);
          });

          this.oldSelectedTypes = [...this.selectedVehicleType];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    helperForUpdateVehicle() {
      // update old selected values
      this.oldSelectedTypes.length = 0;
      this.deleteSelected.length = 0;
      this.selectedVehicleType.length = 0;
      setTimeout(() => {
        this.getVehicleTypeFields();
        this.hideLoading();
      }, 1000);
    },
    updateVehicleType() {
      this.showVehicleTypeModal = false;
      if (!this.selectedVehicleType.length) {
        this.showLoading();
        this.deleteVehicleType();
        this.helperForUpdateVehicle();
        return;
      }

      if (this.selectedVehicleType.length) {
        this.showLoading();
        this.deleteVehicleType();
        this.selectedVehicleType.forEach((element) => {
          this.addVehicleType(element);
        });

        this.helperForUpdateVehicle();
      }
    },
    async addVehicleType(name) {
      await this.$http
        .post(process.env.API_BASE_URL_CS + "driver-tags/", {
          tag: 26,
          driver: this.$route.params.id_driver,
          value: name,
        })
        .then((res) => {
          // console.log(res)
        })
        .catch((error) => {
          this.showToastError(error);
        });
    },
    deleteVehicleType() {
      console.log("delete");
      this.deleteSelected.forEach((element) => {
        if (element) {
          this.$http
            .patch(process.env.API_BASE_URL_CS + "driver-tags/" + element + "/")
            .then((res) => {
              console.log(res);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
    },
    updateAccountType() {
      this.showAccountTypeModal = false;
      this.showLoading();
      this.$http
        .patch(
          process.env.API_BASE_URL_CS +
            "drivers/" +
            this.driver.id_driver.id +
            "/?type=update_account_type",
          {
            id_type_driver_account: this.selected_account_type,
          }
        )
        .then((response) => {
          this.hideLoading();
          this.getDriver();
          this.getComments();
        })
        .catch((error) => {
          this.hideLoading();
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);

          error = error.response.data;
          if ("non_field_errors" in error) {
            error = error["non_field_errors"][0];
          } else {
            if (Array.isArray(error)) {
              error = error[0];
            } else {
              let name = Object.keys(error)[0];
              error = error[name][0] + " for " + name + ".";
            }
          }
          this.showToastError(error);
        });
    },
    pickerChanged(event) {
      console.log(event);
    },
    clearDate(date) {
      if (date == "min_date") {
        this.min_date = null;
      }
      if (date == "max_date") {
        this.max_date = null;
      }
    },
    selectAll() {
      this.checked = this.mergedRides;
    },
    unselectAll() {
      this.checked = [];
    },
    checkSelection: function (event) {
      // this.data.isCheckAll =  ? false : true
      if (event.srcElement.selectedIndex == 1) {
        this.selectAll();
      }
      if (event.srcElement.selectedIndex == 2) {
        this.unselectAll();
      }
    },
    showLoading() {
      this.isLoading = true;
      this.loadings.push(1);
    },
    hideLoading() {
      if (this.loadings.length > 0) {
        this.loadings.pop();
      }
      if (this.loadings.length == 0) {
        this.isLoading = false;
      }
    },
    updateDriver() {
      this.showLoading();
      var url =
        process.env.API_BASE_URL_CS +
        "users/" +
        this.$route.params.id_driver +
        "/";
      var params = {
        name_first: this.driver.name_first,
        name_last: this.driver.name_last,
        email: this.driver.email,
        phone_number: this.driver.phone_number,
        username: this.driver.email,
        bio: this.driver.bio,
        location_address_1: this.driver.location_address_1,
        location_county: this.driver.location_county,
      };
      this.$http
        .patch(url, params)
        .then((response) => {
          this.getBalance();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
          this.errors = error.response.data;
          this.non_field_errors = error.response.data.non_field_errors;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    updateBankInfo() {
      this.isLoading = true;
      if (!this.accountNumber || !this.routingNumber || !this.ssn) {
        this.showToastError("Please fill in all fields");
        this.isLoading = false;
        return;
      }
      this.$http
        .post(process.env.API_BASE_URL + "updateBankAccount/", {
          id: this.$route.params.id_driver,
          account_number: this.accountNumber,
          routing_number: this.routingNumber,
          ssn: this.ssn,
        })
        .then((response) => {
          this.showToastError("Success!");
        })
        .catch((error) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    payBalance(manual = false) {
      if (manual) {
        if (!this.manualPayoutAmount || this.manualPayoutAmount <= 0) {
          alert("The amount should be greater than 0");
          return;
        }

        if (this.manualPayoutAmount > this.balance) {
          alert("The amount should not be greater than the balance");
          return;
        }
      }

      if (!confirm("Are you sure to process the transfer?")) {
        return;
      }

      let data = {
        id_driver: this.$route.params.id_driver,
      };

      if (this.manualPayoutAmount && this.manualPayoutAmount > 0) {
        data = {
          id_driver: this.$route.params.id_driver,
          amount: this.manualPayoutAmount,
        };
      }

      this.showLoading();
      this.$http
        .post(
          process.env.API_BASE_URL_CS + "transactions/?type=pay_balance",
          data
        )
        .then((response) => {
          this.showManualPayoutModal = false;
          this.manualPayoutAmount = null;
          this.getBalance();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
          this.errors = error.response.data;
          this.non_field_errors = error.response.data.non_field_errors;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getBalance() {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "users/" +
            this.$route.params.id_driver +
            "/?type=balance"
        )
        .then((response) => {
          this.balance = response.data.balance;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getPayments: function () {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "transactions/?type=payment_history&id_user=" +
            this.$route.params.id_driver
        )
        .then((response) => {
          this.payments = response.data.results;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          if (this.payments.length > 0) {
            $("#payments-table").DataTable({
              displayLength: 5,
              lengthMenu: [5, 10, 25, 50],
              lengthChange: true,
              searching: false,
              ordering: false,
              retrieve: true,
            });
          }
        });
    },
    viewDashboard() {
      this.$router.push("/driver-dashboard/" + this.driver.id_user + "/");
    },
    changeDriverStatus(id_type_driver_status) {
      if ([2, 3].includes(id_type_driver_status)) {
        this.showDriverDistributionModal = true;
      }

      this.showLoading();
      this.$http
        .patch(
          process.env.API_BASE_URL_CS +
            "drivers/" +
            this.driver.id_driver.id +
            "/?type=update_driver_status",
          {
            id_type_driver_status: id_type_driver_status,
          }
        )
        .then((response) => {
          this.getDriver();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
          this.getComments();
        });
    },
    getComments: function () {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "user-comments/?id_user=" +
            this.$route.params.id_driver +
            "&page_size=999"
        )
        .then((response) => {
          this.comments = response.data.results.reverse();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
          if (this.comments && this.comments.length > 0) {
            $("#comments-table").DataTable({
              displayLength: 5,
              lengthMenu: [5, 10, 25, 50],
              lengthChange: true,
              searching: false,
              ordering: false,
              retrieve: true,
            });
          }
        });
    },
    addComment: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "user-comments/", {
          id_user: this.$route.params.id_driver,
          content: this.comment_content,
        })
        .then((response) => {
          this.comment_content = null;
          this.getComments();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
          this.getComments();
        });
    },
    getDriver: function () {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "drivers-search/?id_user=" +
            this.$route.params.id_driver
        )
        .then((response) => {
          this.driver = response.data[0] ? response.data[0] : null;
          this.selected_account_type =
            this.driver.id_driver.id_type_driver_account.id_type_driver_account;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();

          this.initMap();
        });
    },
    changeUpcPage: function (page) {
      this.getUpco(page);
    },
    getUpco: function (page) {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "rides/?type=upco&page_size=" +
            this.perPage +
            "&ordering=date_pickup&id_driver=" +
            this.$route.params.id_driver +
            "&page=" +
            (page ? page : this.upcCurrentPage)
        )
        .then((response) => {
          this.upco = response.data.results ? response.data.results : null;
          this.checked = this.upco;
          this.totalUpcRows = response.data.count;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          // if (this.upco && this.upco.length > 0) {
          //   $("#upcoming-rides-table").DataTable({
          //     displayLength: 5,
          //     lengthMenu: [5, 10, 25, 50],
          //     lengthChange: true,
          //     searching: false,
          //     ordering: false,
          //     retrieve: true,
          //   });
          // }
        });
    },
    getPrev: function (page) {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "rides/?type=prev&page_size=" +
            this.perPage +
            "&id_driver=" +
            this.$route.params.id_driver +
            "&page=" +
            (page ? page : this.prevCurrentPage)
        )
        .then((response) => {
          this.prev = response.data.results ? response.data.results : null;
          this.totalPrevRows = response.data.count;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          // if (this.prev && this.prev.length > 0) {
          //   $("#previous-rides-table").DataTable({
          //     displayLength: 5,
          //     lengthMenu: [5, 10, 25, 50],
          //     lengthChange: true,
          //     searching: false,
          //     ordering: false,
          //     retrieve: true,
          //   });
          // }
        });
    },
    changePrevPage: function (page) {
      this.getPrev(page);
    },
    changeActPage: function (page) {
      this.getActive(page);
    },
    getActive: function (page) {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "rides/?ordering=date_pickup&type=active&page_size=" +
            this.perPage +
            "&id_driver=" +
            this.$route.params.id_driver +
            "&page=" +
            (page ? page : this.actCurrentPage)
        )
        .then((response) => {
          this.active = response.data.results ? response.data.results : null;
          this.totalActRows = response.data.count;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          if (this.active && this.active.length > 0) {
            $("#active-rides-table").DataTable({
              displayLength: 5,
              lengthMenu: [5, 10, 25, 50],
              lengthChange: true,
              searching: false,
              ordering: false,
              retrieve: true,
            });
          }
        });
    },
    addAdditionalPayment() {
      this.showLoading();
      this.$http
        .post(
          process.env.API_BASE_URL_CS + "transactions/?type=extra_payment",
          {
            id_user: this.$route.params.id_driver,
            amount: this.additional_payment_amount,
            comment: this.additional_payment_comment,
          }
        )
        .then((response) => {
          this.showAdditionalModal = false;

          this.showAdditionalModal = false;

          this.additional_payment_amount = null;
          this.additional_payment_comment = null;
          this.getRide();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);

          error = error.response.data;
          if ("non_field_errors" in error) {
            error = error["non_field_errors"][0];
          } else {
            if (Array.isArray(error)) {
              error = error[0];
            } else {
              let name = Object.keys(error)[0];
              error = error[name][0] + " for " + name + ".";
            }
          }
          this.showToastError(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    addInstallmentPayment: function (confirm) {
      this.showLoading();
      this.$http
        .post(
          process.env.API_BASE_URL_CS + "transactions/create-installments/",
          {
            amount: parseInt(this.installment_payment_amount),
            number_of_installments: parseInt(this.installment_count),
            interval: this.installment_interval,
            start: this.moment(this.installment_start_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            description: this.installment_description,
            read_only: confirm ? 0 : 1,
            id_driver: this.$route.params.id_driver,
          }
        )
        .then((response) => {
          this.showInstallmentModal = false;

          console.log(confirm);
          if (confirm) {
            this.installment_payment_amount = null;
            this.installment_count = null;
            this.installment_interval = "week";
            this.installment_start_date = null;
            this.installment_description = null;
            this.showInstallmentConfirmModal = false;
          } else {
            this.installments = response.data;
            this.showInstallmentConfirmModal = true;
          }
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);

          error = error.response.data;
          if ("non_field_errors" in error) {
            error = error["non_field_errors"][0];
          } else {
            if (Array.isArray(error)) {
              error = error[0];
            } else {
              let name = Object.keys(error)[0];
              error = error[name][0] + " for " + name + ".";
            }
          }
          this.showToastError(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    saveZone() {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "zones/", {
          id_driver: this.$route.params.id_driver,
          polygon: this.oldDrawing,
        })
        .then((response) => {
          console.log("saveZone success");
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getZone() {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "zones/?id_driver=" +
            this.$route.params.id_driver
        )
        .then((response) => {
          this.oldDrawing = response.data[0].polygon.replace("SRID=4326;", "");
          this.loadPolygons(this.oldDrawing);
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    loadPolygons: function (source) {
      var wkt = source; //this is your WKT string

      // console.log(wkt)

      //using regex, we will get the indivudal Rings
      var regex = /\(([^()]+)\)/g;
      var Rings = [];
      var results;
      while ((results = regex.exec(wkt))) {
        Rings.push(results[1]);
      }
      // console.log(Rings)

      var shapes = [];

      var polyLen = Rings.length;
      // console.log(polyLen)

      //now we need to draw the polygon for each of inner rings, but reversed
      for (var i = 0; i < polyLen; i++) {
        var ptsArray = [];
        var data = Rings[i];
        // console.log(data)

        //first spilt the string into individual points
        var pointsData = data.split(",");
        // console.log(pointsData)

        //iterate over each points data and create a latlong
        //& add it to the cords array
        var len = pointsData.length;
        for (var j = 0; j < len; j++) {
          var xy = pointsData[j].trim().split(" ");
          // console.log(xy[1])
          // console.log(xy[0])
          var lat = parseFloat(xy[1]).toFixed(6);
          var lng = parseFloat(xy[0]).toFixed(6);
          // console.log(lat)
          // console.log(lng)

          var pt = new google.maps.LatLng(lat, lng);
          ptsArray.push(pt);
        }

        shapes.push(ptsArray);
      }

      for (var i = 0; i < shapes.length; i++) {
        var ptsArray = shapes[i];
        window.poly = new google.maps.Polygon({
          paths: ptsArray,
          strokeColor: "#1E90FF",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#1E90FF",
          fillOpacity: 0.35,
        });

        this.shapes.push(window.poly);

        poly.setMap(this.map);
      }
    },
    saveDraw: function () {
      this.showDraw = true;
      this.showCancel = false;
      this.showSave = false;

      var wkt = "";
      wkt += "MULTIPOLYGON(";

      var polygons = [];
      for (var i = 0; i < this.shapes.length; i++) {
        var coords = this.lines[i]
          .getPath()
          .getArray()
          .map(function (n) {
            return [n.lng().toFixed(6) + " " + n.lat().toFixed(6)];
          });
        coords.push(coords[0]);

        var polygon = "((";
        polygon += coords.join(",");
        polygon += "))";

        if (polygon != "(())") {
          polygons.push(polygon);
        }
      }

      polygons = polygons.join(",");
      wkt += polygons;

      wkt += ")";
      console.log(wkt);

      this.oldDrawing = wkt;
      this.saveZone();

      var map = this.map;
      map.setOptions({
        draggable: true,
        scrollwheel: true,
        zoomControl: true,
        disableDoubleClickZoom: true,
        disableDefaultUI: false,
        streetViewControl: false,
      });

      // this will cause zoom buttons not to work
      google.maps.event.clearInstanceListeners(map);
    },
    cancelDraw: function () {
      this.showDraw = true;
      this.showCancel = false;
      this.showSave = false;

      var fixed = document.getElementById("map");
      fixed.removeEventListener("touchmove", this.preventScroll, false);

      for (var i = 0; i < this.shapes.length; i++) {
        this.shapes[i].setMap(null);
      }

      var map = this.map;
      map.setOptions({
        draggable: true,
        scrollwheel: true,
        zoomControl: true,
        disableDoubleClickZoom: true,
        disableDefaultUI: false,
        fullscreenControl: true,
        mapTypeControl: false,
        streetViewControl: false,
      });

      // this will cause zoom buttons not to work
      google.maps.event.clearInstanceListeners(map);

      this.loadPolygons(this.oldDrawing);
    },
    preventScroll: function (e) {
      e.preventDefault();
    },
    draw: function () {
      this.showDraw = false;
      this.showCancel = true;
      this.showSave = true;

      for (var i = 0; i < this.shapes.length; i++) {
        this.shapes[i].setMap(null);
      }

      this.lines = [];
      this.shapes = [];

      var fixed = document.getElementById("map");
      fixed.addEventListener("touchmove", this.preventScroll, false);

      var map = this.map;
      map.setOptions({
        draggable: false,
        scrollwheel: false,
        zoomControl: false,
        disableDoubleClickZoom: false,
        disableDefaultUI: true,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
      });

      google.maps.event.addListener(map, "mousedown", () => {
        //the polygon
        window.poly = new google.maps.Polyline({
          map: map,
          clickable: false,
          strokeColor: "#1E90FF",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#1E90FF",
          fillOpacity: 0.35,
        });

        //move-listener
        var move = google.maps.event.addListener(
          map,
          "mousemove",
          function (e) {
            window.poly.getPath().push(e.latLng);
          }
        );

        //mouseup-listener
        google.maps.event.addListenerOnce(map, "mouseup", () => {
          google.maps.event.removeListener(move);
          var path = poly.getPath();

          if (!google.maps.geometry) {
            return;
          }

          var line = new google.maps.Polyline({ path: path });
          var encoded = google.maps.geometry.encoding.encodePath(
            line.getPath()
          );
          var tol = 0.0001;
          while (encoded.length > 100) {
            console.log("simplify");
            path = line.simplify(tol);
            line = new google.maps.Polyline({ path: path });
            encoded = google.maps.geometry.encoding.encodePath(path);
            tol += 0.001;
          }

          window.poly.setMap(null);
          window.poly = new google.maps.Polygon({
            map: map,
            path: path,
            strokeColor: "#1E90FF",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#1E90FF",
            fillOpacity: 0.35,
          });

          path = line.getPath();

          this.lines.push(line);
          this.shapes.push(window.poly);

          var coords = path.getArray().map(function (n) {
            return [n.lng().toFixed(6) + " " + n.lat().toFixed(6)];
          });
          coords.push(coords[0]);

          var wkt = "";
          wkt += "MULTIPOLYGON(";
          wkt += "((";
          wkt += coords.join(",");
          wkt += "))";
          wkt += ")";

          console.log(wkt);

          // google.maps.event.clearListeners(map.getDiv(), 'mousedown')

          // enable()
        });
      });
    },
    initMap: function () {
      google.maps.Polyline.prototype.simplify = function (tolerance) {
        var points = this.getPath().getArray(); // An array of google.maps.LatLng objects
        var keep = []; // The simplified array of points

        // Check there is something to simplify.
        if (points.length <= 2) {
          return points;
        }

        function distanceToSegment(p, v, w) {
          function distanceSquared(v, w) {
            return Math.pow(v.x - w.x, 2) + Math.pow(v.y - w.y, 2);
          }

          function distanceToSegmentSquared(p, v, w) {
            var l2 = distanceSquared(v, w);
            if (l2 === 0) return distanceSquared(p, v);

            var t =
              ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
            if (t < 0) return distanceSquared(p, v);
            if (t > 1) return distanceSquared(p, w);
            return distanceSquared(p, {
              x: v.x + t * (w.x - v.x),
              y: v.y + t * (w.y - v.y),
            });
          }

          // Lat/Lng to x/y
          function ll2xy(p) {
            return { x: p.lat(), y: p.lng() };
          }

          return Math.sqrt(
            distanceToSegmentSquared(ll2xy(p), ll2xy(v), ll2xy(w))
          );
        }

        function dp(points, tolerance) {
          // If the segment is too small, just keep the first point.
          // We push the final point on at the very end.
          if (points.length <= 2) {
            return [points[0]];
          }

          var keep = [], // An array of points to keep
            v = points[0], // Starting point that defines a segment
            w = points[points.length - 1], // Ending point that defines a segment
            maxDistance = 0, // Distance of farthest point
            maxIndex = 0; // Index of said point

          // Loop over every intermediate point to find point greatest distance from segment
          for (var i = 1, ii = points.length - 2; i <= ii; i++) {
            var distance = distanceToSegment(
              points[i],
              points[0],
              points[points.length - 1]
            );
            if (distance > maxDistance) {
              maxDistance = distance;
              maxIndex = i;
            }
          }

          // check if the max distance is greater than our tollerance allows
          if (maxDistance >= tolerance) {
            // Recursivly call dp() on first half of points
            keep = keep.concat(dp(points.slice(0, maxIndex + 1), tolerance));

            // Then on second half
            keep = keep.concat(
              dp(points.slice(maxIndex, points.length), tolerance)
            );
          } else {
            // Discarding intermediate point, keep the first
            keep = [points[0]];
          }
          return keep;
        }

        // Push the final point on
        keep = dp(points, tolerance);
        keep.push(points[points.length - 1]);
        return keep;
      };

      var center_x = this.driver.id_driver.id_market.center_x;
      var center_y = this.driver.id_driver.id_market.center_y;

      var map = new google.maps.Map(document.getElementById("map"), {
        center: {
          lat: center_x ? center_x : 33.637,
          lng: center_y ? center_y : -84.431,
        },
        zoom: 9,
        minZoom: 7,
        draggableCursor: "default",
        fullscreenControl: true,
        mapTypeControl: false,
        streetViewControl: false,
      });

      this.map = map;

      var drawingManager = new google.maps.drawing.DrawingManager({
        // drawingMode: google.maps.drawing.OverlayType.MARKER,
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [],
        },
        markerOptions: {
          icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        },
        polygonOptions: {
          fillColor: "#0074e4",
          fillOpacity: 1,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1,
        },
      });
      drawingManager.setMap(map);
      this.getZone();
    },
    resetPassword() {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL +
            "sent-reset-password-link/?username=" + encodeURIComponent(this.driver.email)
        )
        .then((response) => {
          Vue.toasted.show(
            "Password reset email was sent to " + this.driver.email,
            {
              theme: "outline",
              position: this.toastPosition,
              duration: 2000,
            }
          );
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    sendTestRide() {
      this.showLoading();
      this.$http
        .post(
          process.env.API_BASE_URL +
          "cs/send-driver-test-ride/?id_driver=" +
          this.driver.id_user + '&id_booker=' + this.getUser().id_user
        )
        .then((response) => {
          this.testRideId = response.data.id_ride
          this.showTestRideConfirmModal = true
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    distributeDriver: function () {
      console.log(this.checked);
      let ids = [];
      for (let index = 0; index < this.checked.length; index++) {
        let id = this.checked[index].id_ride;
        ids.push(id);
      }
      console.log("ids " + ids);

      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL +
            "distributeDriver/?id=" +
            this.$route.params.id_driver +
            "&ids=" +
            ids
        )
        .then((response) => {})
        .catch((error) => {
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
          this.getUpco();
          this.getActive();
        });
    },
  },
  mounted() {
    this.getDriver();
    this.getPayments();
    this.getComments();
    this.getPrev();
    this.getUpco();
    this.getActive();
    this.getBalance();
    this.getVehicleTypeFields();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.actions button {
  color: #333268;
  background-color: #00f9b9;
  border: none;
  margin-bottom: 5px;
}

.actions button:hover {
  background-color: red;
}

.card-map-body button {
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: bold;
  margin-top: 10px;
}
</style>


<style>
.modal-body {
  max-height: 80vh !important;
  overflow: unset !important;
}

.cus-pagination {
  background-color: rgba(0, 0, 0, 0.05);
  float: left;
  width: 100%;
}
</style>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/Drivers.vue